export default __webpack_public_path__ + "media/images/community/symbol-dark-17b347f71fc5cd2da6982d0eff884978.svg";